import { faCustomWorkflow01 } from "@awesome.me/kit-8280cfc532/icons/kit/custom";
import type { IconDefinition } from "@awesome.me/kit-8280cfc532/icons";

export const kitIcons: IconDefinition[] = [faCustomWorkflow01];
